const text = {
    "Test":"ENDGLISH@!!!!",
        "Login:view:username":"BANANA",
        "CredentialDetailsCombo:view:username":"User details",
        "CredentialDetailsCombo:view:cardid":"Edit user",
        "Administrator":"Admin",
        "Administratoren":"Admin",
        "User":"User",
        "Created":"Created",
        "CreatedBy":"Creator",
        "Action":"Action",
        "Yes":"Yes",
        "No":"No",
        "IP":"IP",
        'Hostname':'Hostname',
		"Username":"Username",
        "Tag":"Tag",
        "Tags":"Tags",
        "tags":"Tags",
        "Options":"Options",
        "AddScan":"Add scan",
        "Delete":"Delete",
        "Target":"Target",
        "Notification":"Notification",
        "Language":"DE",
        "Interval":"Interval",
        "Progress":"Progress",
        "Logout":"Logout",
        "days":"days",
        "hours":"hours",
        "Scanjobs":"Scanjobs",
        "Description":"Description",
        "Active":"Active",
        "Config":"Config",
        "Setup":"Setup",
        "Parallel":"Parallel",
        "Depends":"Depends",
        "Rule":"Rule",
        "Submit":"Submit",
        "FullName":"Full name",
        "Details":"Details",
        "Login":"Login",
        "Dashboard":"Dashboard",   
        "NetzwerkScan":"Networkscan",
        "Watchdog":"Watchdog",
        "Alle Vulnerabilites":"All vulnerabilites",
        "Alle Reports":"All reports ",
        "Netzwerkuebersicht":"Network graph ",
        "Admininsrator":"Admin",
        "Targets":"Targets",
        "Scans":"Scans",
        "Name":"Name",
        "Vulnerabilities":"Vulnerabilities",
        "Updated":"Updated",
        "Scannerstatus":"Scannerstatus",
        "Ping":"Ping",
        "Nodedistance":"Nodedistance",
        "LastScan":"Last scan",
        "NextScan":"Next scan",
        "LowSeverity":"Low severity",
        "MediumSeverity":"Medium severity",
        "HighSeverity":"High severity",
        "Report":"Report",
        "Issue":"Issue",
        "Version":"Version",
        "OSVersion":"OS version",
        "accuracy":"Accuracy",
        "ModifyTarget":"Modify target",
        "Ziele":"Targets",
        "TargetInformation":"Target information",
        "Software":"Software",
        "AdditionalInformation":"Additional information",
        "SoftwareName":"Softwarename",
        "TopVulnerabilities":"Top vulnerabilities",
		"Actions":"Actions",
		"Role":"Role",
		"Createuser":"Create new user",
        "Severity":"Severity",
        "Type":"Type",
        "ActiveTargetlist":"Active targetlist",
        "Attention":"Attention",
        "Groupname":"Groupname",
        "Message":"Message",
        "FinishedScan":"Finished scan",
        "Severity1-5":"Severity 1-5",
        "Severity5-7":"Severity 5-7",
        "Severity7-10":"Severity 7-10",
        "Credentials":"Credentials ",
        "Scan Rule":"Scan rule ",
        "Mandanten":"Clients",
        "CompanyName":"Company name",
        "CustomerName":"Customer name",
        "CustomerPhone":"Customer phone",
        "CustomerMail":"Customer mail",
        "Title":"Title",
        "Lastname":"Lastname",
        "Phone":"Phone",
        "Mail":"Mail",
        "Street":"Street",
        "Postcode":"Postcode",
        "Contact":"Contact",
        "Customer":"Customer",
        "City":"City",
        "Country":"Country",
        "127.0.0.1":"127.0.0.1",
        "RuleName":"Rule name",
		"keyphrase":"keyphrase",
		"passphrase":"passphrase",
		"publicPGPkey":"publicPGPkey",
        "Avatar":"Avatar",
        "Deactivate":"Deactivate",
        "Activate":"Activate",
        "Userlist":"Userlist",
        "E-Mail":"E-mail",
        "Count":"Count",
        "Sev.":"Sev.", 
        "ActiveRanges":"Active ranges",
		"SNMPCOMMUNITY":"SNMP community",
        "Password":"Password",
        "Passwordrepeat":"Repeat password",
        "Gender":"Gender",
        "CreateUser":"Create user",
        "Male":"Male",
        "Female":"Female",
        "Other":"Other",
        "Port":"Port",
        "CredentialsGroup":"Credentials group",
        "fieldrequired":"This field is required",
        "CredGrpinput:cardtitle":" Create new credentials",
        "CredGrpinput:namelabel":"Groupname",
        "CredGrpinput:creat group button":"Create credtinal group",
        "CredInput:option1":"Username + password",
        "CredInput:option2":"Username + SSHKey",
        "CredInput:option3":"Certificate",
        "CredInput:option4":"PGP encryption key",
        "CredInput:option5":"Password only",
        "CredInput:LabelCredGroup":"Credentinal group",
        "CredInput:LabelAllow_insecurity":"Allow unsafe connection",
        "CredInput:LabelUsername":"Username",
        "CredInput:LabelPassword":"Password",
        "CredInput:LabelAuthentic-Algo":"Autentification-algorythm",
        "CredInput:LabelPriv-Algo":"Privacy-algorythm",
        "None":"None",
        "CredInput:CreateCred":"Create credential",
        "CredTab:TitleCredGroups":"Credential groups",
        "Error:404text":"Sorry, an error acurred",
        "Error:404":"Back home",
        "Error:500text":"Page not found",
        "Error:500":"Back home",
        "login:view:Username":"Username",
        "login:view:Password":"Password",
        "Login:view:Logout":"Log out",
        "LogTable:TitleCol1LogType":"Log type",
        "LogTable:TitleCol2Title":"Titel",
        "LogTable:TitleCol3message":"Message",
        "MandantenInput:CardTitle":"Client creator",
        "MandantenInput:LabelClient":"Client",
        "MandantenInput:LabelCustomer":"Costumor information",
        "MandantenInput:LabelContact":"Contact informstion",
        "MandantenInput:LabelCreateClient":"Create client",
        "MandantenTable:TitleCol1Name":"Name",
        "MandantenTable:TitleCol2Contact":"Contact",
        "MandantenTable:TitleCol3Customer":"Customer",
        "MandantenTable:CardTitle":"Clientlist",
        "GraphThingyTable:CardTitle":"Userlist",
        "MyInputThingy:Username":"Username",
        "MyInputThingy:Password":"Password",
        "MyTableThingy:Name":"Name",
        "Issues":"Issues",
        "MyTableThingy:Age":"Age",
        "MyTableThingy:Adress":"Address",
        "MyTableThingy:Userlist":"Userlist",
        "NetworkScanActive:TitleCol1":"Scanrange",
        "NetworkScanActive:TitleCol2Status":"Status",
        "NetworkScanActive:TitleCol3Action":"Action",
        "NetworkScanActive:Delete":"Delete",
        "NetworkScanActive:ActiveNetworkScan":"Queued Network-scan",
        "NetworkScanInput:DetecionScan":"Network detection-scan",
        "NetworkScanInput:NetworkRange":"Networkrange",
        "NetworkScanTable:NoScanDefined":" has no scan defined",
        "NetworkScanTable:willbescanned":" will be scanned ",
        "NetworkScanTable:willbedeleted":" will be deleted ",
        "NetworkScanTable:clicktocancel":"Click to cancel",
        "Network:suretodelete":"Are you sure, you want to delete this task?",
        "Network:netowrkscan":"Network-scan",
        "Network:networkscanrevealed":"Networkscan revealed: ",
        "Network:networkscanactivedevices":" active devices",
        "NetworkTable:TitleCol1":"Address",
        "NetworkTable:TitleCol2Age":"Age",
        "footer:rights":"All rights reserved",
        "NetworkTable:TitleCol3Address":"Address",
        "NetworkTable:Cardtitle":"Networktable",
        "NetworkGraph:Title":"Networkgraph",
        "ReportTable:Identifier":"Identifier",
        "ReportTable:Reporttype":"Reporttype",
        "ReportTable:Reporttitle":"Reports overview",
        "ScanConfigInput:Title":"Scan configurator",
        "ScanConfigInput:Starttime":"Starttime",
        "ScanDetailsCombo:ScanDetails":"Scan details",
        "ScanRuleDetails:TasksIncluded":"Tasks included in ",
        "ScanRuleInput:CreateNewRule":"Create new scan-rule",
        "ScanRuleInput:CreateNew":"Create new scan-rule",
        "ScanRule:CardTitle":"Rule center",
        "TargetDetails:TDFor":"Target details for ",
        "Processing": "Processing",
        "Waiting":"Waiting",
        "WatchdogModifier":"Watchdogmodifier",
        "AddInfo":"Additional Information",
        "OsInfo":"OS Information",
        "ForgotPassword":"Forgot Password",
        "SendResetKey":"Send key",
        "HaveRecoveryKey":"I have a recovery key",
        "VodinDownload:Title":"Download Vodin",
        "VodinDownload:Button":"Vodin {version} ({size})",
        "SetupDownloads:Title":"Installer downloads: {total} in total, {lastDays} in the last 30 days, {today} today",
        "SetupDownloads:Empty":"No downloads yet",
        "SetupDownloads:Version":"Version",
        "SetupDownloads:Today":"Today",
        "SetupDownloads:LastDays":"Last 30 days",
        "SetupDownloads:Total":"Total",
        "ResetToken":"Reset Token",
        "Login:view:Password":"Password",
        "SideMenu:AuthSettings":"Login settings",
        "AuthSettings:AdminOnly":"This page is for administrators only.",
        "AuthSettings:LoadFailed":"The login settings could not be loaded.",
        "AuthSettings:Retry":"Try again",
        "AuthSettings:MethodsTitle":"Login methods and order",
        "AuthSettings:MethodsHint":"The methods are checked in this order; the first one that accepts the login wins.",
        "AuthSettings:LocalOnly":"Active: local login only",
        "AuthSettings:NoLocalWarning":"Local login is removed. Afterwards only people the directory or SSO accepts can log in - administrators included. Test the connection first.",
        "AuthSettings:Method:local":"Local (hub accounts)",
        "AuthSettings:Method:activedirectory":"Active Directory",
        "AuthSettings:Method:ldap":"LDAP",
        "AuthSettings:Method:keycloak":"Keycloak (OIDC)",
        "AuthSettings:Up":"Move up",
        "AuthSettings:Down":"Move down",
        "AuthSettings:Remove":"Remove",
        "AuthSettings:Add":"Add:",
        "AuthSettings:Active":"active",
        "AuthSettings:Inactive":"inactive",
        "AuthSettings:LdapTitle":"LDAP / Active Directory",
        "AuthSettings:Ldap:Server":"Server",
        "AuthSettings:Ldap:Port":"Port",
        "AuthSettings:Ldap:PortHint":"AD Global Catalog 3268, LDAP 389; empty = default",
        "AuthSettings:Ldap:BaseDn":"Base DN",
        "AuthSettings:Ldap:BindDn":"Bind DN",
        "AuthSettings:Ldap:BindPassword":"Bind password",
        "AuthSettings:Ldap:UserAttribute":"User attribute",
        "AuthSettings:Ldap:UserAttributeHint":"AD sAMAccountName, LDAP uid; empty = default",
        "AuthSettings:Ldap:Group":"Required group",
        "AuthSettings:Ldap:GroupHint":"Only members of this group may log in; empty = anyone below the base DN",
        "AuthSettings:KeycloakTitle":"Keycloak / OIDC",
        "AuthSettings:Keycloak:Url":"URL",
        "AuthSettings:Keycloak:Realm":"Realm",
        "AuthSettings:Keycloak:ClientId":"Client ID",
        "AuthSettings:Keycloak:ClientSecret":"Client secret",
        "AuthSettings:Keycloak:Role":"Required role",
        "AuthSettings:Keycloak:RoleHint":"Only accounts with this role may log in; empty = any account in the realm",
        "AuthSettings:Keycloak:RedirectUri":"Redirect URI",
        "AuthSettings:Keycloak:Scope":"Scope",
        "AuthSettings:AutoProvision":"Create accounts automatically",
        "AuthSettings:AutoProvisionHint":"Whoever logs in successfully for the first time gets a hub account with the role below.",
        "AuthSettings:SecretSet":"set",
        "AuthSettings:SecretNotSet":"not set",
        "AuthSettings:SecretPlaceholder":"New value - leave empty to keep the stored one",
        "AuthSettings:SecretHint":"The stored value is never shown, only replaced.",
        "AuthSettings:Test":"Test connection",
        "AuthSettings:TestHint":"This tests the saved settings - save first.",
        "AuthSettings:TestOk":"Connection succeeded",
        "AuthSettings:TestFailed":"Connection failed",
        "AuthSettings:ProvisionTitle":"Automatically created accounts",
        "AuthSettings:ProvisionRole":"Role",
        "AuthSettings:ProvisionRoleHint":"Applies to accounts that LDAP/AD or Keycloak create at their first login.",
        "AuthSettings:Role:Guest":"Guest",
        "AuthSettings:Role:User":"User",
        "AuthSettings:Role:Admin":"Administrator",
        "AuthSettings:Save":"Save",
        "AuthSettings:Saved":"Login settings saved",
        "AuthSettings:SaveRefused":"The hub did not accept the settings:",
        "TargetTolerance":"Target tolerance (%)",
        "HubDefault":"default",
        "SaveTargetTolerance":"Save tolerance",
        "SideMenu:EmergencyUpload":"Emergency upload",
        "EmergencyUpload:Title":"Emergency upload",
        "EmergencyUpload:Warning":"The normal route is the release pipeline. Releases uploaded here stay inactive until they are activated under Updates.",
        "EmergencyUpload:AdminOnly":"This page is for administrators only.",
        "EmergencyUpload:File":"Package",
        "EmergencyUpload:ChooseFile":"Choose file",
        "EmergencyUpload:Software":"Software",
        "EmergencyUpload:Version":"Version",
        "EmergencyUpload:Branch":"Branch",
        "EmergencyUpload:ChooseBranch":"Choose branch",
        "EmergencyUpload:ExpectedSha256":"Expected SHA-256 (optional)",
        "EmergencyUpload:ExpectedSha256Hint":"From the package's .sha256 file. If it differs, the package is refused and set aside.",
        "EmergencyUpload:Upload":"Upload",
        "EmergencyUpload:Uploading":"Uploading …",
        "EmergencyUpload:Refused":"The hub refused the package (HTTP {status})",
        "EmergencyUpload:Accepted":"Version {version} ({branch}) registered",
        "EmergencyUpload:Inactive":"The release is inactive. Spokes are offered it only after it is activated under Updates.",
        "EmergencyUpload:Predecessor":"Predecessor",
        "EmergencyUpload:ToUpdates":"Go to Updates",
        "EmergencyUpload:Another":"Another package",
        "EmergencyUpload:Problem:file-missing":"Please choose a file.",
        "EmergencyUpload:Problem:file-empty":"The file is empty.",
        "EmergencyUpload:Problem:file-too-large":"The file is larger than 1 GiB.",
        "EmergencyUpload:Problem:software-invalid":"Letters, digits, _ and - only.",
        "EmergencyUpload:Problem:version-missing":"Please enter the version, e.g. 7.793.",
        "EmergencyUpload:Problem:version-invalid":"The version must be major.minor, e.g. 7.793; each part at most 2147483647.",
        "EmergencyUpload:Problem:branch-missing":"Please choose a branch.",
        "EmergencyUpload:Problem:sha256-invalid":"A SHA-256 has 64 hexadecimal digits.",
        "EmergencyUpload:Error:version-exists":"This version is already registered for the software.",
        "EmergencyUpload:Error:file-exists":"A file of this name already lies in storage.",
        "EmergencyUpload:Error:sha256-mismatch":"The SHA-256 does not match. The package was moved to gluef-abgelehnt.",
        "EmergencyUpload:Error:package-version-mismatch":"The version inside the package (core/VERSION_ID) differs from the one entered. The package was moved to gluef-abgelehnt.",
        "EmergencyUpload:Error:package-unreadable":"This is not a Vodin update package (core/VERSION_ID missing). It was moved to gluef-abgelehnt.",
        "EmergencyUpload:Error:file-empty":"The file is empty.",
        "EmergencyUpload:Error:file-too-large":"The package is larger than 1 GiB.",
        "EmergencyUpload:Error:version-invalid":"The version must be major.minor, e.g. 7.793.",
        "EmergencyUpload:Error:version-missing":"Please enter the version.",
        "EmergencyUpload:Error:branch-invalid":"Unknown branch.",
        "EmergencyUpload:Error:branch-missing":"Please choose a branch.",
        "EmergencyUpload:Error:upload-aborted":"The upload broke off before the file was complete.",
        "EmergencyUpload:Error:network":"The hub could not be reached, or the connection broke off.",
        "EmergencyUpload:Error:unauthorized":"Not signed in, or the session expired - please sign in again.",
        "Updates:Archive":"Archive",
        "Updates:ArchiveConfirm":"Archive version {version}?",
        "Updates:ArchiveHint":"The entry stays (spokes on this release are still found); the package moves to gluef-archiv.",
        "Updates:ArchiveSelected":"Archive selected",
        "Updates:ArchiveSelectedConfirm":"Archive {count} releases?",
        "Updates:ShowArchived":"Show archived",
        "Updates:ArchivedTag":"archived",
        "Updates:Restore":"Restore",
        "Updates:Cancel":"Cancel",
        "Updates:MustDeactivate":"Deactivate first: an active release is not archived.",
        "Statistic:CpeEntries":"# CPE entries",
        "License:TierUnknown":"unknown",
        "License:IncludedInTier":"(included in {tier})",
        "License:Remove":"Remove",
        "License:RemoveConfirm":"Remove this licence?",
        "License:RemoveHint":"The licence is archived, not deleted; the spoke gets no new token for it.",
        "License:Cancel":"Cancel",
        "License:Restore":"Restore",
        "License:ArchivedTag":"removed",
        "License:ShowArchived":"Show removed",
        "License:ForeignKeyTag":"foreign key",
        "License:ForeignKeyHint":"The spoke checks this licence with a licence key that is not this hub's, i.e. runs on licences this hub did not issue. The hub refuses it a token. Reported key:",
        "License:UnusedTag":"unused",
        "License:UnusedHint":"No machine took this licence, or its machine has not been in contact for a long time. Only unused licences can be removed.",
        "License:RemoveInUse":"The licence is still in use and was not removed.",
        "License:RemoveSelected":"Remove selected ({count})",
        "License:RemoveSeveralConfirm":"Remove {count} licences?",
        "License:RemoveSeveralDone":"Removed: {archived}, already removed: {unchanged}, refused: {refused}.",
        "License:RemoveSeveralFailed":"The licences were not removed.",
    
    }

    export default text

